import * as React from "react";
import PropTypes from "prop-types";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Drawer, { drawerClasses } from "@mui/material/Drawer";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import SwapHorizRoundedIcon from "@mui/icons-material/SwapHorizRounded";
import MenuContent from "./MenuContent";
import { useNavigate } from "react-router-dom";
import KEYCLOAK_CONFIG from "../config/keycloakConfig";

function SideMenuMobile({ open, toggleDrawer }) {
  const navigate = useNavigate();
  const userName = localStorage.getItem("userName");
  const displayName = userName
    ? userName.split("@")[0]
    : localStorage.getItem("userName");
  const companyName = localStorage.getItem("companyName");

  const handleLogout = () => {
    const idToken = localStorage.getItem("idToken");
    localStorage.clear();

    // Keycloak session'ı da sonlandır
    if (idToken) {
      const logoutUrl =
        `${KEYCLOAK_CONFIG.realmUrl}/protocol/openid-connect/logout` +
        `?id_token_hint=${encodeURIComponent(idToken)}` +
        `&post_logout_redirect_uri=${encodeURIComponent(KEYCLOAK_CONFIG.redirectUri)}`;
      window.location.href = logoutUrl;
    } else {
      navigate("/login");
    }
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: "none",
          backgroundColor: "background.paper",
        },
      }}
    >
      <Stack
        sx={{
          maxWidth: "70dvw",
          height: "100%",
        }}
      >
        <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1 }}>
          <Stack
            direction="row"
            sx={{ gap: 1, alignItems: "center", flexGrow: 1, p: 1 }}
          >
            <Avatar
              sizes="small"
              alt={displayName}
              // src="/static/images/avatar/7.jpg"
              sx={{ width: 24, height: 24 }}
            />
            <Typography component="p" variant="h6">
              {displayName}
            </Typography>
          </Stack>
        </Stack>
        <Divider />
        <Stack sx={{ flexGrow: 1 }}>
          <MenuContent />
          <Divider />
        </Stack>
        <Stack sx={{ p: 2, gap: 1 }}>
          {companyName && (
            <Button
              variant="outlined"
              fullWidth
              startIcon={<SwapHorizRoundedIcon />}
              onClick={() => {
                toggleDrawer(false)();
                navigate("/client");
              }}
            >
              {companyName}
            </Button>
          )}
          <Button
            variant="outlined"
            fullWidth
            startIcon={<LogoutRoundedIcon />}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
}

SideMenuMobile.propTypes = {
  open: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
};

export default SideMenuMobile;
